<template>
  <div class="partnership-page flex-col">
    <div class="partnership-page__content flex-col">
      <div class="partnership-hero flex-col">
        <app-header
          class="partnership-header"
          title="合作赋能"
          :brand-icon="require('@/assets/pages/partnership/images/7b3e39ff066de7577886d3160d535ff3.png')"
          :menu-icon="require('@/assets/pages/partnership/images/01d4ab8fef8a2e57aba69b2acec884c1.png')"
        />
      </div>
      <div class="partnership-hero__campaign flex-col">
        <span class="partnership-hero__heading">合作伙伴计划</span>
        <span class="partnership-hero__summary">加入智谷优学，享专业支持，让优质服务触手可及。</span>
        <button class="partnership-hero__cta flex-col" type="button" @click="openContact">
          <span class="partnership-hero__cta-label">成为合作伙伴</span>
        </button>
      </div>
      <div class="partnership-pain-points flex-col">
        <div class="partnership-pain-points__heading flex-row">
          <div class="partnership-pain-points__heading-rule-start flex-col"></div>
          <span class="partnership-pain-points__title">你的痛点，我们懂</span>
          <div class="partnership-pain-points__heading-rule-end flex-col"></div>
        </div>
        <div class="partnership-pain-points__illustration flex-col">
          <div class="partnership-pain-points__illustration-frame flex-col"><div class="partnership-pain-points__illustration-artwork flex-col"></div></div>
        </div>
      </div>
      <div class="partnership-pain-points__institution flex-col">
        <div class="partnership-pain-points__audience-label flex-col"><span class="partnership-pain-points__audience-name">志愿填报机构</span></div>
        <div class="partnership-pain-points__service-gap flex-col">
          <span class="partnership-pain-points__service-gap-copy">
            学生填报完成后就服务结束，手握众多资源无法
            <br />
            再利用
          </span>
        </div>
        <div class="partnership-pain-points__brand-gap flex-col">
          <span class="partnership-pain-points__brand-gap-copy">
            用的是别人的工具，品牌价值感不强，
            <br />
            且不能定制
          </span>
        </div>
        <div class="partnership-pain-points__acquisition-gap flex-col"><span class="partnership-pain-points__acquisition-gap-copy">获客渠道匮乏，招生越来越难</span></div>
        <div class="partnership-pain-points__differentiation-gap flex-col"><span class="partnership-pain-points__differentiation-gap-copy">产品同质化严重，无法差异化竞争</span></div>
      </div>
      <div class="partnership-empowerment flex-col">
        <div class="partnership-empowerment__heading flex-row">
          <div class="partnership-empowerment__heading-rule-start flex-col"></div>
          <span class="partnership-empowerment__title">我们能提供什么?</span>
          <div class="partnership-empowerment__heading-rule-end flex-col"></div>
        </div>
        <div class="partnership-empowerment__eyebrow flex-row justify-between">
          <span class="partnership-empowerment__eyebrow-index">NO.1</span>
          <span class="partnership-empowerment__eyebrow-title">全方位赋能</span>
        </div>
        <div class="partnership-empowerment__brand-catalog-offers flex-row">
          <div class="partnership-empowerment__brand-ip-offer flex-col">
            <div class="partnership-empowerment__brand-ip-copy">
              <span class="partnership-empowerment__brand-ip-title">
                1.品牌IP赋能
                <br />
              </span>
              <span class="partnership-empowerment__brand-ip-description">
                共享权威资质、
                <br />
                名校教研背书，
                <br />
                快速放大品牌公信力。
              </span>
            </div>
          </div>
          <div class="partnership-empowerment__product-suite-offer flex-col">
            <div class="partnership-empowerment__product-suite-frame flex-col">
              <div class="partnership-empowerment__product-suite-panel flex-col">
                <div class="partnership-empowerment__product-suite-copy">
                  <span class="partnership-empowerment__product-suite-title">
                    2.全品类产品赋能
                    <br />
                  </span>
                  <span class="partnership-empowerment__product-suite-description">
                    涵盖高中填报、
                    <br />
                    家长课堂、营地教育、
                    <br />
                    论文辅导等，
                    <br />
                    实现全周期服务升级。
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partnership-empowerment__acquisition-technology-offers flex-row justify-between">
          <div class="partnership-empowerment__customer-acquisition-offer flex-col">
            <div class="partnership-empowerment__customer-acquisition-frame flex-col">
              <div class="partnership-empowerment__customer-acquisition-panel flex-col">
                <div class="partnership-empowerment__customer-acquisition-copy">
                  <span class="partnership-empowerment__customer-acquisition-title">
                    3.标准化拓客方案
                    <br />
                  </span>
                  <span class="partnership-empowerment__customer-acquisition-description">
                    提供可落地的拓客物料，
                    <br />
                    手把手教引流与转化。
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="partnership-empowerment__technology-offer flex-col">
            <div class="partnership-empowerment__technology-frame flex-col">
              <div class="partnership-empowerment__technology-panel flex-col">
                <div class="partnership-empowerment__technology-copy">
                  <span class="partnership-empowerment__technology-title">
                    4.技术与师资赋能
                    <br />
                  </span>
                  <span class="partnership-empowerment__technology-description">
                    一对一培训，
                    <br />
                    共享专家导师，
                    <br />
                    补齐师资短板。
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partnership-empowerment__operations-offer flex-col">
          <span class="partnership-empowerment__operations-visual-title">
            智谷优学
            <br />
            全方位赋能
          </span>
          <div class="partnership-empowerment__operations-panel flex-col">
            <div class="partnership-empowerment__operations-copy">
              <span class="partnership-empowerment__operations-title">
                5.运营售后赋能
                <br />
              </span>
              <span class="partnership-empowerment__operations-description">专属人员全程跟进，合作方"只管拓客，后续无忧"。</span>
            </div>
          </div>
        </div>
        <div class="partnership-cooperation-modes__eyebrow flex-row justify-between">
          <span class="partnership-cooperation-modes__eyebrow-index">NO.2</span>
          <span class="partnership-cooperation-modes__eyebrow-title">专属填报软件</span>
        </div>
        <span class="partnership-cooperation-modes__intro">提供两种合作赋能模式</span>
        <div class="partnership-cooperation-modes__options flex-col justify-between">
          <div class="partnership-channel-mode flex-col">
            <div class="partnership-channel-mode__overview flex-row">
              <div class="partnership-channel-mode__identity flex-row justify-between">
                <img
                  class="partnership-channel-mode__icon"
                  referrerpolicy="no-referrer"
                  src="@/assets/pages/partnership/images/9e3e9fc3634e7a8146e7988bd1c0a73a.png"
                />
                <div class="partnership-channel-mode__summary flex-col justify-between">
                  <span class="partnership-channel-mode__title">模式一：渠道合作</span>
                  <span class="partnership-channel-mode__description">
                    依托东大一帆成熟小程序平台进行品牌嫁接
                    <br />
                    融合，快速上线、成本更低、无需从零开发
                  </span>
                </div>
              </div>
            </div>
            <div class="partnership-channel-mode__features flex-col">
              <div class="partnership-channel-mode__features-heading flex-row"><span class="partnership-channel-mode__features-title">模式特点：</span></div>
              <div class="partnership-channel-mode__launch-standardization-features flex-row justify-between">
                <div class="partnership-channel-mode__feature-launch">
                  <span class="partnership-channel-mode__feature-launch-marker">·</span>
                  <span class="partnership-channel-mode__feature-launch-copy">一键开通，无需技术开发</span>
                </div>
                <div class="partnership-channel-mode__feature-standardized">
                  <span class="partnership-channel-mode__feature-standardized-marker">·</span>
                  <span class="partnership-channel-mode__feature-standardized-copy">标准化系统，开箱即用</span>
                </div>
              </div>
              <div class="partnership-channel-mode__data-efficiency-features flex-row justify-between">
                <div class="partnership-channel-mode__feature-synchronization">
                  <span class="partnership-channel-mode__feature-synchronization-marker">·</span>
                  <span class="partnership-channel-mode__feature-synchronization-copy">数据实时同步</span>
                </div>
                <div class="partnership-channel-mode__feature-efficiency">
                  <span class="partnership-channel-mode__feature-efficiency-marker">·</span>
                  <span class="partnership-channel-mode__feature-efficiency-copy">成本低，见效快</span>
                </div>
              </div>
            </div>
            <div class="partnership-channel-mode__audience flex-col">
              <div class="partnership-channel-mode__audience-heading flex-row"><span class="partnership-channel-mode__audience-title">适合人群：</span></div>
              <div class="partnership-channel-mode__lean-launch-audiences flex-row justify-between">
                <div class="partnership-channel-mode__audience-fast-launch">
                  <span class="partnership-channel-mode__audience-fast-launch-marker">·</span>
                  <span class="partnership-channel-mode__audience-fast-launch-copy">快速上线业务的机构</span>
                </div>
                <div class="partnership-channel-mode__audience-no-tech">
                  <span class="partnership-channel-mode__audience-no-tech-marker">·</span>
                  <span class="partnership-channel-mode__audience-no-tech-copy">无技术团队的规划师</span>
                </div>
              </div>
              <div class="partnership-channel-mode__market-entry-audience flex-row">
                <div class="partnership-channel-mode__audience-market-entry">
                  <span class="partnership-channel-mode__audience-market-entry-marker">·</span>
                  <span class="partnership-channel-mode__audience-market-entry-copy">试水市场的转型者</span>
                </div>
              </div>
            </div>
          </div>
          <div class="partnership-custom-mode flex-col">
            <div class="partnership-custom-mode__overview flex-row">
              <div class="partnership-custom-mode__identity flex-row justify-between">
                <img
                  class="partnership-custom-mode__icon"
                  referrerpolicy="no-referrer"
                  src="@/assets/pages/partnership/images/97be597777b142698d4c159fc51d3e60.png"
                />
                <div class="partnership-custom-mode__summary flex-col justify-between">
                  <span class="partnership-custom-mode__title">模式二：品牌专属定制合作</span>
                  <span class="partnership-custom-mode__description">
                    深度定制开发，独立搭建专属小程序及后台
                    <br />
                    服务，功能按需配置，品牌完全私有化。
                  </span>
                </div>
              </div>
            </div>
            <div class="partnership-custom-mode__features flex-col">
              <div class="partnership-custom-mode__features-heading flex-row"><span class="partnership-custom-mode__features-title">模式特点：</span></div>
              <div class="partnership-custom-mode__brand-module-features flex-row justify-between">
                <div class="partnership-custom-mode__feature-branding">
                  <span class="partnership-custom-mode__feature-branding-marker">·</span>
                  <span class="partnership-custom-mode__feature-branding-copy">Logo、界面、品牌定制</span>
                </div>
                <div class="partnership-custom-mode__feature-modules">
                  <span class="partnership-custom-mode__feature-modules-marker">·</span>
                  <span class="partnership-custom-mode__feature-modules-copy">功能模块按需配置</span>
                </div>
              </div>
              <div class="partnership-custom-mode__feature-integration-row flex-row">
                <div class="partnership-custom-mode__feature-integration">
                  <span class="partnership-custom-mode__feature-integration-marker">·</span>
                  <span class="partnership-custom-mode__feature-integration-copy">对接现有系统，数据互通</span>
                </div>
              </div>
              <div class="partnership-custom-mode__feature-support-row flex-row">
                <div class="partnership-custom-mode__feature-support">
                  <span class="partnership-custom-mode__feature-support-marker">·</span>
                  <span class="partnership-custom-mode__feature-support-copy">专属团队支持二次开发</span>
                </div>
              </div>
            </div>
            <div class="partnership-custom-mode__audience flex-col">
              <div class="partnership-custom-mode__audience-heading flex-row"><span class="partnership-custom-mode__audience-title">适合人群：</span></div>
              <div class="partnership-custom-mode__established-business-audiences flex-row justify-between">
                <div class="partnership-custom-mode__audience-brand-builders">
                  <span class="partnership-custom-mode__audience-brand-builders-marker">·</span>
                  <span class="partnership-custom-mode__audience-brand-builders-copy">有规模想建品牌的机构</span>
                </div>
                <div class="partnership-custom-mode__audience-integrators">
                  <span class="partnership-custom-mode__audience-integrators-marker">·</span>
                  <span class="partnership-custom-mode__audience-integrators-copy">需对接现有系统的企业</span>
                </div>
              </div>
              <div class="partnership-custom-mode__differentiation-audience flex-row">
                <div class="partnership-custom-mode__audience-differentiators">
                  <span class="partnership-custom-mode__audience-differentiators-marker">·</span>
                  <span class="partnership-custom-mode__audience-differentiators-copy">追求差异化竞争的机构</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="partnership-advantages flex-col">
        <div class="partnership-advantages__heading flex-row justify-between">
          <div class="partnership-advantages__heading-rule-start flex-col"></div>
          <span class="partnership-advantages__title">为什么选择我们?</span>
          <div class="partnership-advantages__heading-rule-end flex-col"></div>
        </div>
        <span class="partnership-advantages__intro">
          不同于传统教育机构，智谷优学独创差异化路径；
          <br />
          以硬核工业智能技术为根基，深度反哺新工科高校教育
          <br />
          建设为青少年全周期成长筑牢核心壁垒；
          <br />
          打造不可复制的竞争优势
        </span>
        <div class="partnership-advantages__network-endorsement-cards flex-row justify-between">
          <div class="partnership-advantages__local-network-card flex-col">
            <div class="partnership-advantages__local-network-badge flex-col"><span class="partnership-advantages__local-network-index">1</span></div>
            <div class="partnership-advantages__local-network-copy flex-col justify-between">
              <span class="partnership-advantages__local-network-title">
                本土发源立根，全国
                <br />
                覆盖拓局
              </span>
              <span class="partnership-advantages__local-network-description">
                辽宁本土深耕，熟知本地
                <br />
                考情政策；全国资源联动，
                <br />
                本土精细化与全国优质化
                <br />
                双向融合。
              </span>
            </div>
            <img
              class="partnership-advantages__local-network-illustration"
              referrerpolicy="no-referrer"
              src="@/assets/pages/partnership/images/9889a609232dff2f2ff9ad8d6707a9e5.png"
            />
          </div>
          <div class="partnership-advantages__academic-endorsement-card flex-col">
            <div class="partnership-advantages__academic-endorsement-badge flex-col"><span class="partnership-advantages__academic-endorsement-index">2</span></div>
            <div class="partnership-advantages__academic-endorsement-copy flex-col justify-between">
              <span class="partnership-advantages__academic-endorsement-title">
                顶尖资源背书，专业性
                <br />
                拉满
              </span>
              <span class="partnership-advantages__academic-endorsement-description">
                东北大学、大连理工等
                <br />
                985高校教研支持，
                <br />
                清北中科院等全国优质
                <br />
                资源，专业性远超行业。
              </span>
            </div>
            <img
              class="partnership-advantages__academic-endorsement-illustration"
              referrerpolicy="no-referrer"
              src="@/assets/pages/partnership/images/ea642f87cbbeccebb335f234c9474252.png"
            />
          </div>
        </div>
        <div class="partnership-advantages__lifecycle-technology-cards flex-row justify-between">
          <div class="partnership-advantages__full-cycle-card flex-col">
            <div class="partnership-advantages__full-cycle-badge flex-col"><span class="partnership-advantages__full-cycle-index">3</span></div>
            <div class="partnership-advantages__full-cycle-copy flex-col justify-between">
              <span class="partnership-advantages__full-cycle-title">
                全周期覆盖，产品体系
                <br />
                完善
              </span>
              <span class="partnership-advantages__full-cycle-description">
                高中到大学全阶段服务，
                <br />
                产品品类齐全无断层，
                <br />
                满足各类学涯需求。
              </span>
            </div>
            <img
              class="partnership-advantages__full-cycle-illustration"
              referrerpolicy="no-referrer"
              src="@/assets/pages/partnership/images/96f9bf9aecc93dbd6078ca3a16de5629.png"
            />
          </div>
          <div class="partnership-advantages__technology-practice-card flex-col">
            <div class="partnership-advantages__technology-practice-badge flex-col"><span class="partnership-advantages__technology-practice-index">4</span></div>
            <div class="partnership-advantages__technology-practice-copy flex-col justify-between">
              <span class="partnership-advantages__technology-practice-title">
                科技+实践结合，
                <br />
                本土+全国双适配
              </span>
              <span class="partnership-advantages__technology-practice-description">
                自主智能小程序提升效率，
                <br />
                线下营地实践深化体验，
                <br />
                本土精准与全国覆盖兼顾。
              </span>
            </div>
            <img
              class="partnership-advantages__technology-practice-illustration"
              referrerpolicy="no-referrer"
              src="@/assets/pages/partnership/images/6ffdf7d581f4c640af45393b5bf163a4.png"
            />
          </div>
        </div>
      </div>
      <div class="partnership-credentials flex-col">
        <div class="partnership-credentials__doctoral-team">
          <span class="partnership-credentials__doctoral-team-title">博士团队</span>
          <span class="partnership-credentials__doctoral-team-detail">（源自东北大学）</span>
        </div>
        <div class="partnership-credentials__research-ecosystem">
          <span class="partnership-credentials__research-ecosystem-title">产学研生态</span>
          <span class="partnership-credentials__research-ecosystem-detail">（三大板块闭环赋能）</span>
        </div>
        <div class="partnership-credentials__university-resources">
          <span class="partnership-credentials__university-resources-title">高校资源</span>
          <span class="partnership-credentials__university-resources-detail">（十余所高校合作）</span>
        </div>
        <div class="partnership-credentials__technology-strength">
          <span class="partnership-credentials__technology-strength-title">技术雄厚</span>
          <span class="partnership-credentials__technology-strength-detail">（多项发明专利+软件著作权）</span>
        </div>
        <div class="partnership-credentials__mature-system">
          <span class="partnership-credentials__mature-system-title">体系成熟</span>
          <span class="partnership-credentials__mature-system-detail">（十余年行业深耕）</span>
        </div>
      </div>
      <div class="partnership-process flex-col">
        <div class="partnership-process__heading flex-row">
          <div class="partnership-process__heading-rule-start flex-col"></div>
          <span class="partnership-process__title">从洽谈到运营，仅需7天</span>
          <div class="partnership-process__heading-rule-end flex-col"></div>
        </div>
        <span class="partnership-process__intro">
          我们制定了高效的合作流程，
          <br />
          帮助你和你的机构快速加入智谷优学伙伴计划
        </span>
        <div class="partnership-process__steps flex-row">
          <div
            class="partnership-process__step flex-col"
            :style="{ background: item.backgroundImage }"
            v-for="(item, index) in cooperationSteps"
            :key="index"
          >
            <span class="partnership-process__step-label" v-html="item.label"></span>
          </div>
        </div>
        <div class="partnership-process__timeline flex-row justify-between">
          <img
            class="partnership-process__timeline-line"
            referrerpolicy="no-referrer"
            src="@/assets/pages/partnership/images/bcd10f9abf2196da8c02f5d72a11599a.png"
          />
          <img
            class="partnership-process__timeline-marker"
            referrerpolicy="no-referrer"
            src="@/assets/pages/partnership/images/51b546c5675cb0e09c883088854eb8e4.png"
          />
        </div>
        <div class="partnership-process__day-labels flex-row justify-between">
          <span class="partnership-process__day-consultation">DAY.1</span>
          <span class="partnership-process__day-review">DAY.2</span>
          <span class="partnership-process__day-signing">DAY.3</span>
          <span class="partnership-process__day-operations">DAY.4</span>
        </div>
        <img
          class="partnership-process__review-marker"
          referrerpolicy="no-referrer"
          src="@/assets/pages/partnership/images/a714102aef27b86c5eeb8ebc3c3f7901.png"
        />
        <div class="partnership-process__signing-marker flex-col"><div class="partnership-process__signing-marker-dot flex-col"></div></div>
        <div class="partnership-process__operations-marker flex-col"><div class="partnership-process__operations-marker-dot flex-col"></div></div>
        <div class="partnership-process__completion-marker flex-col"><div class="partnership-process__completion-marker-dot flex-col"></div></div>
      </div>
      <div class="partnership-support flex-col justify-end">
        <div class="partnership-support__contact-card flex-col">
          <div class="partnership-support__heading flex-row"><span class="partnership-support__title">专属合作通道</span></div>
          <div class="partnership-support__contact-details flex-row">
            <img
              class="partnership-support__advisor-portrait"
              referrerpolicy="no-referrer"
              src="@/assets/pages/partnership/images/8abaf77e4db4fecca47a0e63482b805e.png"
            />
            <div class="partnership-support__advisor-copy">
              <span class="partnership-support__advisor-name">
                刘老师
                <br />
              </span>
              <span class="partnership-support__phone-label">手机号：</span>
              <span class="partnership-support__phone-number">
                18640109087
                <br />
              </span>
              <span class="partnership-support__hours-label">工作日：</span>
              <span class="partnership-support__hours-value">9:00～18:00</span>
            </div>
          </div>
        </div>
        <app-footer />
      </div>
      <app-floating-actions ref="floatingActions" />
    </div>
  </div>
</template>
<script>
import AppFloatingActions from '@/components/actions/AppFloatingActions.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import AppHeader from '@/components/navigation/AppHeader.vue'

export default {
  name: 'PartnershipView',
  components: { AppFloatingActions, AppFooter, AppHeader },
  data() {
    return {
      cooperationSteps: [
        {
          backgroundImage: `url(${require('@/assets/pages/partnership/images/remote/fd815a27a857a19c7da41245fe3d5382.png')}) 100% no-repeat`,
          label: '联系我们'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/partnership/images/remote/86e6bdf1718d183559cb918835d0b8d6.png')}) 100% no-repeat`,
          label: '资质审核'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/partnership/images/remote/d1dc03c86fcd35d0aebc6c89d34bfd32.png')}) 100% no-repeat`,
          label: '签约合作'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/partnership/images/remote/2d8c4c1c4884028cfe043a414fdf27ec.png')}) 100% no-repeat`,
          label: '开始运营'
        }
      ]
    };
  },
  methods: {
    openContact() {
      if (this.$refs.floatingActions) {
        this.$refs.floatingActions.openContact()
      }
    }
  }
};
</script>
<style scoped lang="css" src="@/assets/pages/partnership/styles/index.response.css" />
